import axiosInstance from '../utils/axiosInstance';

export type RafDocType =
  | 'raf-docx-fill'
  | 'raf-authorisation'
  | 'raf-pdf-fill'
  | 'raf-affidavit'
  | 'raf-consultation-note'
  | 'raf-checklist';

export const RAF_DOC_LABELS: Record<RafDocType, string> = {
  'raf-docx-fill': 'RAF1 Form (New)',
  'raf-authorisation': 'Authorisation',
  'raf-pdf-fill': 'RAF1 Form (Old)',
  'raf-affidavit': 'Affidavit',
  'raf-consultation-note': 'Consultation Note',
  'raf-checklist': 'MVA Checklist',
};

interface GenerateResponse {
  jobId: string;
  message?: string;
  matterId: string;
}

export const generateRafDocument = async (
  docType: RafDocType,
  matterId: string,
): Promise<string> => {
  const res = await axiosInstance.post<GenerateResponse>(`/${docType}/create`, {
    matterId,
  });
  return res.data.jobId;
};

interface GenerateAllJobResult {
  service: string;
  status: 'queued' | 'failed';
  jobId?: string;
  error?: string;
}

interface GenerateAllResponse {
  success: boolean;
  matterId: string;
  queued: number;
  total: number;
  jobs: GenerateAllJobResult[];
}

export const generateAllRafDocuments = async (
  matterId: string,
): Promise<GenerateAllResponse> => {
  const res = await axiosInstance.post<GenerateAllResponse>(
    `/matters/${matterId}/generate-all`,
    {},
  );
  return res.data;
};
